"use client";

import NextLink from "next/link";

import type { ComponentProps } from "react";
import { cleanHrefWithSiteBasePath } from "./clean-href-with-site-base-path";
import { useRouterContext } from "./context";
import { isExternal } from "./is-external";
import { isSupportedRouterNavigation } from "./is-supported-router-navigation";

export type LinkProps = Omit<ComponentProps<typeof NextLink>, "href"> & {
  href: string;
};

export const Link = ({ href, ...props }: LinkProps) => {
  const { appRouterPathPrefixes, siteBasePath } = useRouterContext();

  if (isExternal(href, siteBasePath)) {
    return <a href={href} {...props} />;
  }

  const cleanedHref = cleanHrefWithSiteBasePath({
    href,
    siteBasePath,
  });

  const isSupportedRouterNavigationForCurrentPage = isSupportedRouterNavigation(
    {
      appRouterPathPrefixes,
      siteBasePath,
      to: cleanedHref,
    },
  );

  if (isSupportedRouterNavigationForCurrentPage) {
    return <NextLink href={cleanedHref} {...props} />;
  }

  return <a href={cleanedHref} {...props} />;
};
